module.exports = __webpack_public_path__ + "static/img/value.610dc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/value.png
// module id = 8PAv
// module chunks = 7